
import { BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicWorkspacesApi extends BaseModulePublicApi {
  basePath = 'workspaces';
};
